import React, { useEffect, useState } from "react";
import axios from "axios";
import "./astrologerGallery.css";

const BASE_URL = "https://dashboard.jyotirvani.com";

const AstrologyGallery = () => {
  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/fetchgallery`)
      .then((res) => {
        const rawImages = res.data?.data || [];
        const folderPath = res.data?.path || "uploads/galleryImage/";
        const fullImages = rawImages.map((item) => ({
          id: item.id,
          src: `${BASE_URL}/${folderPath}${item.image}`,
        }));
        setImages(fullImages);
        setLoading(false);
      })
      .catch(() => {
        setError("Failed to load gallery");
        setLoading(false);
      });
  }, []);

  const handleImageClick = (index) => setCurrentIndex(index);
  const handleClose = () => setCurrentIndex(null);

  const showPrev = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const showNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  if (loading) {
    return (
      <div className="ra-gallery-main-part">
        <div className="container">
          <p className="ra-gallery-status">Loading Gallery...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="ra-gallery-main-part">
        <div className="container">
          <p className="ra-gallery-status error-text">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="ra-gallery-main-part">
      <div className="container">
        <div className="ra-gallery-heading-wrap">
          <h2 className="ra-gallery-title">Astrology Gallery</h2>
          <p className="ra-gallery-subtitle">
            Explore divine moments, rituals, sacred events, and spiritual
            glimpses from our astrology journey.
          </p>
        </div>

        <div className="ra-gallery-grid">
          {images.map((item, index) => (
            <div
              key={item.id}
              className="ra-gallery-card"
              onClick={() => handleImageClick(index)}
            >
              <div className="ra-gallery-img-wrap">
                <img
                  src={item.src}
                  alt={`Gallery ${index + 1}`}
                  className="ra-gallery-img"
                />
              </div>
            </div>
          ))}
        </div>

        {currentIndex !== null && (
          <div className="ra-gallery-modal-overlay" onClick={handleClose}>
            <div
              className="ra-gallery-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button className="ra-gallery-close-btn" onClick={handleClose}>
                ×
              </button>

              <button className="ra-gallery-nav-btn left" onClick={showPrev}>
                &#10094;
              </button>

              <img
                src={images[currentIndex].src}
                alt={`Gallery ${currentIndex + 1}`}
                className="ra-gallery-modal-img"
              />

              <button className="ra-gallery-nav-btn right" onClick={showNext}>
                &#10095;
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AstrologyGallery;